import React from 'react';
import { Label, formatMessage, Flexbox } from 'cw-ui-core';
import Locale from 'src/i18n';
import Tooltip from 'src/components/Tooltip/Tooltip';
import _ from 'lodash';
import css from './NewUsers.scss';

const UserRolesColumn = ({ original, onRowClick }) => {
    const { userRoles, email } = original;
    const roleNames = _.map(userRoles, role => role.name);
    const firstRole = !_.isEmpty(roleNames) ? roleNames[0] : '';
    let bubbleToolTipContent = '';
    let singleRoleToolTip = '';

    // if some roles are there
    if (!_.isEmpty(roleNames)) {
        // if there are more than one roles
        if (roleNames.length > 1) {
            const bubbleToolTipContentRoleNames = roleNames.slice(1);
            bubbleToolTipContent = (
                <div className={css.toolTipContentContainer}>
                    {_.map(bubbleToolTipContentRoleNames, roleName => (
                        <p key={`${email}-${roleName}`}>{roleName}</p>
                    ))}
                </div>
            );
            // if multiple roles are there and first role exceeding 15 characters
            if (firstRole.length > 15) {
                singleRoleToolTip = <span className={css.toolTipContentContainer}>{firstRole}</span>;
            }
        }
        // if only one role is there and its characters exceeding 15 characters
        if (roleNames.length === 1 && firstRole.length > 15) {
            singleRoleToolTip = <span className={css.toolTipContentContainer}>{firstRole}</span>;
        }
    }

    const getBubbleContent = () =>
        roleNames.length > 1 ? (
            <Tooltip toolTipContent={bubbleToolTipContent} className={css.toolTipContainer}>
                <div className={css.moreBubble}>{roleNames.length - 1}</div>
            </Tooltip>
        ) : null;

    const getFirstRoleContent = () =>
        firstRole.length > 15 ? (
            <Tooltip toolTipContent={singleRoleToolTip} className={css.toolTipContainer}>
                <Label automationName="singleRoleToolTip" value={firstRole} />
            </Tooltip>
        ) : (
            <Label automationName="singleRoleToolTip" value={firstRole} />
        );

    return roleNames.length > 0 ? (
        <Flexbox className={css.userNameContainer} onClick={() => onRowClick(original)}>
            {getFirstRoleContent()}
            {getBubbleContent()}
        </Flexbox>
    ) : (
        <Label
            className={css.userNameContainer}
            value={formatMessage(Locale.unassigned)}
            onClick={() => onRowClick(original)}
        />
    );
};

export default UserRolesColumn;
